// extracted by mini-css-extract-plugin
export default {"cls1":"VeloIconLabel-Label_cls1__a1yVN","cls2":"VeloIconLabel-Label_cls2__82t2K VeloIconLabel-Label_cls1__a1yVN"};